(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inyou-science-split"] && !Shopify.designMode) return;
  try {
    
(function() {
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('iss-drawer-open');
  }
  function closeDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('iss-drawer-open');
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-drawer]');
    if (trigger) { e.preventDefault(); openDrawer(trigger.dataset.drawer); return; }

    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.dataset.drawerClose); return; }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.iss__drawer.is-open').forEach(function(d) {
        closeDrawer(d.id);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
